import { defineFetch } from 'resift';

export interface EntitiesRequestQuery {
  entityTypeId: string;
  sortBy?: 'name' | 'editors' | 'members' | 'lastEditedAt';
  sortDirection?: 'asc' | 'desc' | null;
  nameQuery?: string | null;
  page?: number;
  pageSize?: number;
  filterOn?: 'edited' | 'unedited' | null;
}

interface EntitiesRequest {
  query?: EntitiesRequestQuery;
}

export default defineFetch({
  displayName: 'entities list fetch',
  make: () => ({
    request: ({ query }: EntitiesRequest) => ({ http }: any) =>
      http({
        method: 'GET',
        route: '/entities',
        query,
      }),
  }),
});
